<mat-form-field appearance="outline">
  <mat-select
    id="vehicleTypeFilter-select-vehicleTypes"
    placeholder="Vehicle Type"
    [formControl]="vehicleTypeSelector"
    multiple="{{ allowMultiSelect }}"
    [compareWith]="compareIds"
  >
    <mat-option>
      <ngx-mat-select-search
        id="vehicleTypeFilter-input-vehicleType"
        [formControl]="vehicleTypeFiltersControl"
        [placeholderLabel]="'Search...'"
        [noEntriesFoundLabel]="'No matching vehicleTypes'"
      ></ngx-mat-select-search>
    </mat-option>
    <mat-option id="vehicleTypeFilter-option-{{ type.code }}" *ngFor="let type of vehicleTypes" [value]="type">
      {{ type.name }} ({{ type.code }})
    </mat-option>
  </mat-select>
</mat-form-field>
